import React from 'react';
import { useMemo, useRef, useState,useEffect } from 'react';
import moment from 'moment';
import type { Dispatch} from 'umi';
import classNames from 'classnames';
import { connect, history, request, useIntl } from 'umi';
import ProDescriptions from '@ant-design/pro-descriptions';
import { BellOutlined, CheckOutlined, CloseOutlined, EllipsisOutlined } from '@ant-design/icons';
import { Badge, Button, Dropdown, Menu, message, Modal, Space, Spin, Tabs, Tooltip } from 'antd';

import type { MessageCenterState } from '@/models/message';
import type { DraggableModalRefProps } from '../DraggableModal';
import DraggableModal from '../DraggableModal';
import type { MessageInfo } from '@/pages/typings.d';
import { MessageInfoTypeEnum } from '@/pages/typings.d';
import type { ServiceTask } from '@/pages/TaskView/BatchCreateTask/data';
import { getServiceTaskDetail } from '@/pages/TaskView/TaskProcess/service';
import {
  processorHandler,
  serviceItemNames,
} from '@/pages/TaskView/TaskProcess/components/TaskDetail/TaskSummary';
import styles from './index.less';
import console_default from '@/assets/images/inquiry/console_default.png'
import { useRequest } from 'ahooks';
import { serviceTypeMap } from '@/pages/OrderAdministrate/ItemController/_data';
import { useMessageCenterSlot } from '@/providers/SlotProvider';
import { withModalRootContainer } from '@/providers/AntdProvider';

export type MessageCenterProps = {
  messageCenter: MessageCenterState;
  dispatch: Dispatch;
};

type UnreadCount = Record<string, number>;

const { Item } = ProDescriptions;

const MessageCenter: React.FC<MessageCenterProps> = ({ messageCenter, dispatch }) => {
  // 国际化
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  const t = window.$tc('component.MessageCenter.index', intl.formatMessage);

  const [visible, setVisible] = useState<boolean>(false);

  type CurrentTab = '全部' | '公告' | '通知';

  const defaultCount: UnreadCount = {
    total: 0,
    [MessageInfoTypeEnum['通知']]: 0,
    [MessageInfoTypeEnum['公告']]: 0,
  };

  const messageSubTypeMap = {
    task_create: t('t5', '任务创建通知'),
    task_complete: t('t6', '任务完成通知'),
    task_close: t('t7', '任务关闭通知'),
    task_edit: t('t8', '任务修改通知'),
    task_move: t('t9', '任务转交通知'),
    task_process: t('t10', '任务处理通知'),
    new_customer:t('t11',  '新客户提醒'),
    task_process_remind: t('t12', '任务处理提醒'),
    appt_item_sure: '预约订单提醒',
  };
  const [unreadCount, setUnreadCount] = useState<UnreadCount>({ ...defaultCount });
  const [currentTab, setCurrentTab] = useState<CurrentTab>('全部');

  const [messageList, setMessageList] = useState<MessageInfo[]>([]);
  const modalRef = useRef<DraggableModalRefProps>(null);

  const countHandler = () => {
    const count: UnreadCount = { ...defaultCount };
    if (messageCenter.messageList.length) {
      messageCenter.messageList.forEach((item) => {
        if (!item.readFlag) {
          count.total += 1;
          count[item.type] += 1;
        }
      });
    }
    setUnreadCount(count);
  };

  const messageListHanlder = () => {
    let messageList: MessageInfo[] = [];
    if (currentTab === '全部') {
      messageList = [...messageCenter.messageList];
    } else {
      messageList = messageCenter.messageList.filter((item) => {
        return item.type === MessageInfoTypeEnum[currentTab];
      });
    }
    setMessageList(messageList);
  };

  const deleteMessage = (message: MessageInfo) => {
    withModalRootContainer(Modal.confirm)({
      title: t('t15', '删除'),
      content: t('t16', '确认要删除该条消息？'),
      onOk() {
        dispatch({ type: 'messageCenter/deleteMessage', payload: message });
      },
    });
  };

  const batchDeleteMessage = () => {
    withModalRootContainer(Modal.confirm)({
      title: t('t17', '删除'),
      content: t('t18', '确认要删除所有已读消息？'),
      onOk() {
        dispatch({ type: 'messageCenter/batchDeleteReadedMessage' });
      },
    });
  };

  const readAllMessage = () => {
    withModalRootContainer(Modal.confirm)({
      title: t('t19', '提示'),
      content: t('t20', '确认要将所有消息设为已读吗？'),
      onOk() {
        dispatch({ type: 'messageCenter/readAllMessage' });
      },
    });
  };

  const getMessageList = (payload?: any) => {
    dispatch({ type: 'messageCenter/getMessageList', payload });
  };

  useEffect(() => {
    countHandler();
  }, [messageCenter.messageList]);

  useEffect(() => {
    messageListHanlder();
  }, [messageCenter.messageList, currentTab]);

  const tabBarExtraContentOverlay = (
    <Menu>
      <Menu.Item key="0" onClick={() => getMessageList()}>
        {t('t21', '查看所有消息')}
      </Menu.Item>
      <Menu.Item key="1" onClick={() => getMessageList({ readFlag: false })}>
        {t('t22', '仅看未读消息')}
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="2" onClick={() => readAllMessage()}>
        {t('t23', '标记所有为已读')}
      </Menu.Item>
      <Menu.Item key="3" onClick={() => batchDeleteMessage()}>
        {t('t24', '删除所有已读消息')}
      </Menu.Item>
    </Menu>
  );

  const tabBarExtraContent = (
    <Dropdown trigger={['click']} placement="bottomCenter" overlay={tabBarExtraContentOverlay}>
      <EllipsisOutlined style={{ fontSize: 28, cursor: 'pointer' }} />
    </Dropdown>
  );

  //设置弹窗
  let MessageCenterTooltip = false
  const [MessageCentervisible, setMessageCentervisible] = useState<boolean>(MessageCenterTooltip)
  // localStorage.removeItem('RightContentVisible')
  //判断本地里有没有存值 如果有的话就代表已经弹过弹窗  无需再提示 否则就提示并把值存到本地
    useMemo(()=>{
      if(localStorage.getItem('RightContentVisible')){
        MessageCenterTooltip = false
      }else{
        setTimeout(()=>{
          setMessageCentervisible(true)
          setTimeout(() => {
            setMessageCentervisible(false)
          }, 5000);
        },6000)
      }
    },[])
  const messageText = <span>{t('t36', '查看所有信息，及时处理任务')}</span>
  const color = 'blue';


  //设置提示框的样式
  const object={
    width:'200px',
    height:'auto',
    borderRadius:'6px',
    fontSize:'16px',
    marginTop:'-1px'
  }
  const [, updateMessageCenterSlot] = useMessageCenterSlot()
  useEffect(() => {
    updateMessageCenterSlot({
      count: unreadCount.total,
      setVisible,
    })
  }, [unreadCount.total, updateMessageCenterSlot])
  return (
    <>
      <Badge size="small" count={unreadCount.total}>
      <Tooltip placement="bottom" title={messageText} color={color} open={MessageCentervisible} overlayInnerStyle={object}>
      <BellOutlined
          className={styles.messageIcon}
          style={{ top: 0 }}
          onClick={() => {
            modalRef.current?.setMode('NORMAL');
            setVisible(true);
          }}
        />
      </Tooltip>

      </Badge>
      <DraggableModal
        ref={modalRef}
        title={t('t37', "消息中心")}
        width="1100px"
        bodyStyle={{ height: 620, padding: 0 }}
        footer={false}
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
      >
        <div className={styles.messageContainer}>
          <div className={styles.messageListWrap}>
            <div
              className={styles.tabs}
              style={{ padding: '0 16px', borderBottom: '1px solid #f0f0f0' }}
            >
              <Tabs
                activeKey={currentTab}
                onChange={(e) => setCurrentTab(e as CurrentTab)}
                tabBarExtraContent={tabBarExtraContent}
              >
                <Tabs.TabPane
                  tab={t('t38', '全部') + (unreadCount.total ? '(' + unreadCount.total + ')' : '')}
                  key="全部"
                  style={{ marginLeft: 16 }}
                />
                <Tabs.TabPane
                  tab={t('t40', '公告') + (
                    unreadCount[MessageInfoTypeEnum['公告']]
                      ? '(' + unreadCount[MessageInfoTypeEnum['公告']] + ')'
                      : ''
                  )}
                  key="公告"
                />
                <Tabs.TabPane
                  tab={t('t43', '通知') + (
                    unreadCount[MessageInfoTypeEnum['通知']]
                      ? '(' + unreadCount[MessageInfoTypeEnum['通知']] + ')'
                      : ''
                  )}
                  key="通知"
                />
              </Tabs>
            </div>
            <div className={styles.messageList}>
              <div style={{ overflowY: 'auto', height: '100%' }}>
                {messageList.map((item) => (
                  <div
                    key={item.id}
                    className={classNames(
                      styles.messageItem,
                      item.id === messageCenter?.currentMessage?.id ? styles.active : '',
                    )}
                    onClick={() =>
                      dispatch({ type: 'messageCenter/onMessageListClick', payload: item })
                    }
                  >
                    <div className={styles.messageItemTop}>
                      <span className={styles.title}>{messageSubTypeMap[item.subType as keyof typeof messageSubTypeMap]}</span>
                      <span className={styles.time}>
                        {moment(item.createTime).format('YYYY-MM-DD HH:mm')}
                      </span>
                    </div>
                    <div className={styles.messageItemBottom}>
                      <Tooltip title={item.content}>
                        <span className={styles.text}>{item.content}</span>
                      </Tooltip>
                      <div className={styles.right}>
                        <Space className={styles.operate}>
                          <CheckOutlined
                            className={classNames(styles.icon, styles.check)}
                            onClick={(e) => {
                              console.log('123123');
                              dispatch({ type: 'messageCenter/readMessage', payload: item });
                              e.stopPropagation();
                            }}
                          />
                          <CloseOutlined
                            className={classNames(styles.icon, styles.close)}
                            onClick={(e) => {
                              deleteMessage(item);
                              e.stopPropagation();
                            }}
                          />
                        </Space>
                        <Badge className={styles.dot} dot={!item.readFlag}>
                          {/* 纠正小红点消失位置 */}
                          <span style={{ visibility: 'hidden' }}>1</span>
                        </Badge>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={styles.rightContainer}>
            {messageCenter.currentMessage ? (
              contentRender({
                msg: messageCenter.currentMessage,
                t,
                setMode: modalRef.current?.setMode,
              })
            ) : (
              <div className={styles.placeholder}>
                <img src={console_default} />
              </div>
            )}
          </div>
        </div>
      </DraggableModal>
    </>
  );
};

const mapToProps = ({ messageCenter }: { messageCenter: MessageCenterState }) => {
  return {
    messageCenter,
  };
};

export default connect(mapToProps)(MessageCenter);

interface RenderProps {
  msg: MessageInfo,
  t: ReturnType<typeof window.$tc>,
  setMode?: DraggableModalRefProps['setMode']
}

function contentRender(props: RenderProps) {
  if (props.msg.subType === 'appt_item_sure') {
    return <ApptItemSureDetail {...props} />
  }
  return <TaskDetail {...props} />
}

function TaskDetail(props: RenderProps) {
  const [loading, setLoading] = useState<boolean>(false);
  const [taskDetail, setTaskDetail] = useState<ServiceTask>();
  useEffect(() => {
    if (props.msg) {
      setLoading(true);
      setTaskDetail(undefined);
      getServiceTaskDetail({ id: props.msg.relateData.id })
        .then(({ code, msg, data }) => {
          if (code === 200) {
            setTaskDetail(data);
          } else {
            message.error(msg);
          }
        })
        .finally(() => setLoading(false));
    } else {
      setTaskDetail(undefined);
    }
  }, [props.msg]);
  return (
    <Spin spinning={loading} style={{ height: '100%' }}>
      <div className={styles.taskWrap}>
        <div className={styles.taskTitle}>
          <span>{props.t('t25', '任务概括')}</span>
        </div>
        <ProDescriptions column={24} className={styles.proDesc}>
          <Item span={24} label={props.t('t26', "服务项目")}>
            {serviceItemNames(taskDetail?.serviceItems)}
          </Item>
          <Item span={24} label={props.t('t27', "任务来源")}>
            {taskDetail?.dataSource}
          </Item>
          <Item span={10} label={props.t('t28', "任务创建者")}>
            {processorHandler(taskDetail?.createUserInfo)}
          </Item>
          <Item span={14} label={props.t('t29', "任务转交者")}>
            {processorHandler(taskDetail?.moveUserInfo)}
          </Item>
          <Item span={10} label={props.t('t30', "实际执行者")}>
            {processorHandler(taskDetail?.handlerInfo)}
          </Item>
          <Item span={14} label={props.t('t31', "实际执行时间")}>
            <span>{taskDetail?.processTimeB || '/'}</span>
          </Item>
          <Item span={10} label={props.t('t32', "计划执行者")}>
            {processorHandler(taskDetail?.processorInfo, taskDetail?.processorType)}
          </Item>
          <Item span={14} label={props.t('t33', "计划执行时间")}>
            <Space split=" ~ " size={0}>
              <span>{taskDetail?.planningTimeB}</span>
              <span>{taskDetail?.planningTimeE}</span>
            </Space>
          </Item>
          <Item span={24} label={props.t('t34', "任务描述")}>
            <span>{taskDetail?.desc}</span>
          </Item>
        </ProDescriptions>
        <div className={styles.btnWrap}>
          <Button type="primary" onClick={() => {
            if (taskDetail) {
              history.push(`/TaskView/TaskProcessDetail?id=${taskDetail.id}&from=messageCenter`);
              props.setMode?.('MIN')
            }
          }}>
            {props.t('t35', '查看更多详情')}
          </Button>
        </div>
      </div>
    </Spin>
  );
}

function ApptItemSureDetail(props: RenderProps) {
  const { data, loading } = useRequest(()=>request('/hm/mall/manage/apptOrder/detailInfo', {
    params: {
      id: props.msg.relateData.apptId,
    },
  }), {
    refreshDeps: [props.msg],
  })
  const getApptBookingTime = (r?: any) => {
            if (
              moment(r?.bookingStartTime).format('YYYY-MM-DD') ===
              moment(r?.bookingEndTime).format('YYYY-MM-DD')
            ) {
              return (
                <Space>
                  {moment(r?.bookingStartTime).format('YYYY-MM-DD')}
                  <span>
                    {moment(r?.bookingStartTime).format('HH:mm')}
                    ~
                    {moment(r?.bookingEndTime).format('HH:mm')}
                  </span>
                </Space>
              )
            }
            return (
              <Space>
                {moment(r?.bookingStartTime).format('YYYY-MM-DD HH:mm')}
                ~
                {moment(r?.bookingEndTime).format('YYYY-MM-DD HH:mm')}
              </Space>
            )
          }
  return (
    <Spin spinning={loading} style={{ height: '100%' }}>
      <div className={styles.taskWrap}>
        <div className={styles.taskTitle}>
          <span>预约订单提醒</span>
        </div>
        <ProDescriptions column={24} className={styles.proDesc}>
          <Item span={24} label='预约项目'>
            {data?.data?.apptItemTitle ?? '/'}
          </Item>
          <Item span={24} label='所属店铺'>
            {data?.data?.shopName ?? '/'}
          </Item>
          <Item span={24} label='服务形式'>
            {data?.data?.locationType ? serviceTypeMap.get(data.data.locationType) : '/'}
          </Item>
          <Item span={24} label='联系方式 '>
            {data?.data?.bookingPhone ?? '/'}
          </Item>
          <Item span={24} label='预约时间'>
            {getApptBookingTime(data?.data)}
          </Item>
        </ProDescriptions>
        <div className={styles.btnWrap}>
          <Button type="primary" onClick={() => {
            if (data?.data) {
              history.push('/OrderAdministrate/OrderForm');
              props.setMode?.('MIN')
            }
          }}>
            {props.t('t35', '查看更多详情')}
          </Button>
        </div>
      </div>
    </Spin>
  )
}
